import { WAC_TO_CPAPI_LOCALE_MAP } from '@/utils/content-queries/constants';
import { SupportedLocales } from '@/utils/localization';

type State = 'draft' | 'published';

export const getLiveComposition = async (
	queryParams: URLSearchParams,
	route: string,
	currLocale: SupportedLocales = 'en-US',
) => {
	const projectId = queryParams.get('projectId');
	const compositionId = queryParams.get('compositionId');
	const compositionState: State = (queryParams.get('compositionState') as State) ?? 'draft';
	const contentfulEnv = queryParams.get('contentfulEnv') ?? 'master';
	const contentfulState: State = (queryParams.get('contentfulState') as State) ?? 'draft';
	const locale = queryParams.get('locale') ?? WAC_TO_CPAPI_LOCALE_MAP[currLocale] ?? 'en-US';
	const pageUrl = route.startsWith('/') ? route : `/${route}`;

	const wacmanParams = new URLSearchParams({
		projectId: projectId ?? '',
		compositionId: compositionId ?? '',
		compositionState,
		contentfulEnv,
		contentfulState,
		locale,
		pageUrl,
		hydrate: 'true',
	});

	const baseEndpoint = process.env['WAC_MANAGEMENT_API_BASE_URL'];
	if (!baseEndpoint) {
		console.warn('getLiveComposition: WAC_MANAGEMENT_API_BASE_URL is not configured');
		return undefined;
	}

	const controller = new AbortController();
	const timeoutId = setTimeout(() => controller.abort(), 5000);

	const endpoint = `${baseEndpoint}/api/v1/uniform/composition/get?${wacmanParams.toString()}`;

	try {
		const response = await fetch(endpoint, {
			method: 'GET',
			headers: { 'Content-Type': 'application/json' },
			signal: controller.signal,
		});
		clearTimeout(timeoutId);
		if (!response.ok) {
			console.warn(`getLiveComposition: wac-management-service responded ${response.status}`);
			return undefined;
		}
		const result = await response.json();
		if (result.error) {
			console.warn('getLiveComposition: error in response:', result.error);
		}
		return result.composition;
	} catch (e) {
		clearTimeout(timeoutId);
		const err = e instanceof Error ? e : new Error(String(e));
		console.warn(`getLiveComposition: fetch failed - ${err.name}: ${err.message}`);
		return undefined;
	}
};
